export default __webpack_public_path__ + "static/media/lock2.aa7be85f.svg";